import timePicker from "../../../components/timePicker/timePicker";
import QuickBtnGroup from "../../../components/QuickBtnGroup/QuickBtnGroup";

import $ from 'jquery';
import _ from 'underscore';
import run from '../../../utilities/run';
import render from "../../../utilities/render";
import {handleDisplayFor} from "../../../utilities/selectorHelpers";
import typeAheadSource from "../../../utilities/typeAheadSource";
import loadModal from "./scheduleReportModal";
import {setOptionsForSelect} from "../../../utilities/selectorHelpers";
import {displayCustomReporting, getDropDownDisplayValue} from "./reportsUtil";
import {isPresent} from "../.././../utilities/general";

require("./reports.less");

import ConfigPanel from "../../ConfigPanel/ConfigPanel";
// const targetSelector = "#p_p_id_fxobulkshipment_WAR_rmsportlet_";
const targetSelector = ".reports-outer";
// const targetSelector = "#p_p_id_productnew_WAR_productportlet_";

run(targetSelector, (outerEl)=>{
  const mainEl = $(targetSelector);

  const cancelModal = $(render(
    require("../../../sharedHtml/modal.html"),
    {
      topCloseBtn:true,
      title:'Are you sure you want to cancel this schedule',
      footerBtns:'<a href="#" class="base-btn v2-btn purple-btn m-close-btn">Cancel</a>\
      <a href="#" class="base-btn purple-btn cancel-report-btn">Submit</a>',
      body:"<div class='q-pad-vert-xl q-marg-horz-xl'>Once you cancel this schedule, this report will no longer be sent to the previous recipients.</div>"
    }
  ));

  $('body').append(cancelModal);

  const data = {};    
  setData();
  function setData() {
    data.getReportParamsUrl = outerEl.data("get-report-params-url");
    data.scheduleReportUrl = outerEl.data("schedule-report-url");
    data.cancelScheduleUrl = outerEl.data("cancel-schedule-url");
    data.getReportUrl = outerEl.data("get-report-url");
    data.reportId = outerEl.data("report-id");
    data.report = outerEl.data("report");
    data.params = outerEl.data("params");
    data.paramDetails = outerEl.data("param-details");
    data.schedules = outerEl.data("schedules");
    data.scheduleRows = [];
    
    //console.log("data.report", data.report);
    //console.log("data.params", data.params);
    //console.log("data.paramDetails", data.paramDetails);
    //console.log("data.schedules", data.schedules);
  }

  const noScheduledReportsEl = mainEl.find('.no-scheduled-reports-notification');
  const scheduleCountPill = mainEl.find('#scheduleCountPill');
  const reportParamsInputAnchor = mainEl.find('#reportParamsInputAnchor');
  const reportScheduleListOuter = mainEl.find('.report-schedule-list-outer');
  const customReportingForm = mainEl.find('#customReportingForm');
  const crtId = mainEl.find('#crtId');
  const expandIcon = mainEl.find('#expandScheduleIcon');
  const createScheduleBtn = mainEl.find('.create-schedule-btn');
  const createScheduleBtnParams = mainEl.find('.create-schedule-btn-w-params');
  const createSechduleBtn2= mainEl.find('.scheduled-reports-create-new-btn-div');
  const extraDetailForCacheFromServer  = mainEl.data("extra-detail-for-cache-from-server");

  
  //$('#reportFrame').hide();

  //START: Page JS
  $('.top-close-btn').click(function(e) {
    cancelModal.modal("hide");
  });
  
  $('#expandScheduleIcon').click(function(e) {
    e.preventDefault();
    $('#scheduleCountPill').toggleClass("hidden");
  });

  $('.expand-icon').click(function(e) {
    e.preventDefault();
    $(this).toggleClass("fa-compress fa-expand");
  });

  $('#runReportBtn').click(function(e) {
    e.preventDefault();
    
    if(!$("#customReportingForm").valid()){
      return false;
    }
    getReportUrl();  
   
    
  });

 $.validator.addMethod('validCustomDateRate',function validCustomDateRate(){
    let date1 = $('#DATE_RANGE1').val();
    let date2 = $('#DATE_RANGE2').val();
    let dateRange = $('#DATE_RANGE').val();
    if(dateRange != 'customDate'){
      return true;
    }
    if(isPresent(date1) && isPresent(date2)){
      let dateRange1 = new Date(date1);
      let dateRange2 = new Date(date2);

      return dateRange1 <= dateRange2; 
    }else if (!isPresent(date1) || !isPresent(date2)){
      return true;
    }
  }, 'Please enter dates in order.');

   $.validator.addMethod('bothDatesExists', function bothDatesExists(){
     let date1 = $('#DATE_RANGE1').val();
     let date2 = $('#DATE_RANGE2').val();
    return (isPresent(date1) && isPresent(date2));

   }, 'Both start and end dates are required.');
 
  $("#customReportingForm").validate({
    errorPlacement: function(error, element) {

      let appendClosest = $(element).data('error-placement-append-closest');
      if (appendClosest) {
        $(element).closest(appendClosest).append(error);
      } else {
        error.insertAfter(element);
      }
    },

    // Place all your validation rules here!!!
    rules: {
      "DATE_RANGE1": {
        validCustomDateRate: true,
        bothDatesExists: true
      }
    }
  });

  function serializeForm(form) {
      var o = {};
      var a = form.serializeArray();

      $.each(a, function() {
        let el = $(`#${this.name}`);
        if(el.hasClass('split-button')){
          this.value = $(`#${this.name}-values`).val().join(",");
        }

        if (o[this.name] !== undefined) {
            if (!o[this.name].push) {
                o[this.name] = [o[this.name]];
            }
            o[this.name].push(this.value || '');
        } else {
            o[this.name] = this.value || '';
        }
      });
      return o;
  };

  createScheduleBtn.click(function(e) {
    createScheduleModal([]);
  });

  createScheduleBtnParams.click(function(e) {
    e.preventDefault();
    var isDisabled = $(this).attr("disabled") == "disabled";
    if(!isDisabled){
      let reportParamInput = serializeForm(customReportingForm);
      createScheduleModal(reportParamInput);
    }
      
    
  });

  function createScheduleModal(reportParamInput){
    loadModal(data.getReportParamsUrl, data.scheduleReportUrl, data.reportId,
      reportParamInput, {jobId: 0}, function(response) {

      data.schedules.scheduledJobsList.push(response.data);
      checkDisplayNoScheduledReports();
      updateScheduleCountPill();
      displaySchedules();
    });
  }

  checkDisplayNoScheduledReports();
  updateScheduleCountPill();
  displayCustomReporting(mainEl, reportParamsInputAnchor,
    data.params, data.paramDetails, false);
  displaySchedules();

  function displaySchedules() {
    //console.log("data.schedules.scheduledJobsList", data.schedules.scheduledJobsList);
    reportScheduleListOuter.empty();
    if (data.schedules.scheduledJobsList == null) { data.schedules.scheduledJobsList = [] }

    data.schedules.scheduledJobsList.forEach(function (schedule, index) {
      let recipients = [];
      if (schedule.email) {
        recipients = schedule.email.split(';');
      }

      schedule.reportParams.forEach(function(param, index) {
        param.displayValue = getDropDownDisplayValue(mainEl, param.cspKey, data.paramDetails, param.cspValue);
      });

      let scheduleRow = $(render(
        require("./html/reportSchedule.html"),
        {
          scheduleName: schedule.jobName,
          jobId: schedule.jobId,
          jobName: schedule.jobName,
          nextScheduledRun: schedule.nextRunTime,
          endRun: schedule.jobEndDate,
          reportParams: schedule.reportParams,
          paramDetails:  data.paramDetails,
          runFrequency: schedule.runFrequency,
          recipients: recipients,
        }
      ));
      scheduleRow.find(".delete-report-schedule").on("click", onCancelScheduleClick);
      scheduleRow.find(".edit-report-schedule").on("click", onEditScheduleClick);
      scheduleRow.appendTo(reportScheduleListOuter);
      data.scheduleRows[schedule.jobId] = scheduleRow;
    });
  }

  function onCancelScheduleClick() {
    //console.log(data.cancelScheduleUrl);
    let cancelButton = $(this);

    cancelModal.data("jobId", cancelButton.data("jobId"));
    cancelModal.data("jobName", cancelButton.data("jobName"));
    cancelModal.modal("show");
    cancelModal.on("click", ".m-close-btn", function() {
      cancelModal.modal("hide");
    });
  }

  cancelModal.on("click", ".cancel-report-btn", function() {
      cancelSchedule(cancelModal.data("jobId"), cancelModal.data("jobName"),
        function(response) {
          let removeId = null;
          //console.log('cancelModal.data("jobId")', cancelModal.data("jobId"));
          data.schedules.scheduledJobsList = $.grep(data.schedules.scheduledJobsList, function(schedule) {
            return schedule.jobId != cancelModal.data("jobId")
          });
          checkDisplayNoScheduledReports();
          updateScheduleCountPill();
          displaySchedules();
          data.scheduleRows[cancelModal.data("jobId")].hide();
          cancelModal.modal("hide");
        });
    });

  function cancelSchedule(jobId, jobName, successCallback) {
    $.ajax({
      url: data.cancelScheduleUrl,
      type: 'POST',
      data: { jobId: jobId, jobName: jobName },
      dataType: 'JSON',
      // DONT DO THIS
      // async: false,
      success: successCallback,
      error: function(error) {
        //console.log('Error Returned: ', error);
      }
    });
  }

  function onEditScheduleClick() {
    //console.log(data.cancelScheduleUrl);
    let reportParamInput = [];
    let scheduleParams = {};
    let jobId = $(this).data("jobId");

    data.schedules.scheduledJobsList.forEach(function (curSched, index) {
      if (curSched.jobId == jobId) {
        scheduleParams.jobName = curSched.jobName;
        scheduleParams.dayOfMonth = curSched.dayOfMonth;
        scheduleParams.commaSepDays = curSched.commaSepDays;
        scheduleParams.jobEndDate = curSched.jobEndDate;
        scheduleParams.runTime = curSched.runTime;
        scheduleParams.runFrequency = curSched.runFrequency;
        scheduleParams.specificDay = curSched.specificDay;
        scheduleParams.email = curSched.email;
        scheduleParams.jobId = curSched.jobId;

        curSched.reportParams.forEach(function (param, index) {
          reportParamInput[param.cspKey] = param.cspValue;
        });
      }
    });

    loadModal(data.getReportParamsUrl, data.scheduleReportUrl, data.reportId,
      reportParamInput, scheduleParams, function(response) {
        replaceSchedule(response.data);
        checkDisplayNoScheduledReports();
        updateScheduleCountPill();
        displaySchedules();
      });
  }

  function replaceSchedule(schedule) {
    let replaceIndex = -1;

    data.schedules.scheduledJobsList.forEach(function (curSchedule, index) {
      if (curSchedule.jobId == schedule.jobId) {
        replaceIndex = index;
      }
    });

    if (replaceIndex >= 0) {
      data.schedules.scheduledJobsList[replaceIndex] = schedule;
    }
  }


  function updateScheduleCountPill() {
    if (data.schedules.scheduledJobsList == null || data.schedules.scheduledJobsList.length === 0) {
      scheduleCountPill.text('No Schedules Saved');
      expandIcon.hide();
    } else if (data.schedules.scheduledJobsList.length > 1) {
      scheduleCountPill.text(data.schedules.scheduledJobsList.length + ' Schedules Saved');
      expandIcon.show();
    } else {
      scheduleCountPill.text('1 Schedule Saved');
      expandIcon.show();
    }

  }

  function checkDisplayNoScheduledReports() {
    if (data.schedules.scheduledJobsList == null || data.schedules.scheduledJobsList.length === 0) {
      noScheduledReportsEl.show();
      createSechduleBtn2.hide();
    } else {
      noScheduledReportsEl.hide();
      createSechduleBtn2.show();
    }
  }

  function getReportUrl() {
    let reqData = customReportingForm.serialize();
    reqData += `&reportId=${data.reportId}`

    let popupWindow = window.open('about:blank','_blank');

    let searchRequest = $.ajax({
      url: data.getReportUrl,
      type: 'POST',
      data: reqData,
      dataType: 'JSON',
      // DONT DO THIS
      // async: false,
      success: function(urlResponse) {
        /*if($("#expandCustomIcon").hasClass('fa-compress')){
          $("#expandCustomIcon").trigger('click');
        }*/

        //$("#reportFrame").show();
        //$("#reportIFrame").attr("src", urlResponse.url);

        popupWindow.location.href = urlResponse.url;
      },
      error: function(error) {
        //console.log('Error Returned: ', error);
        popupWindow.close();
      }
    });
  }
});



// WEBPACK FOOTER //
// ./src/pages/report/lookup/reports.js